import { TFunction } from 'react-i18next';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { CartItemViewData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { EJRecordTypes } from '../enumerations/ej-record-types';
import { ITareWeight } from '../interfaces/dtos/ITareWeight';
import { IElectronicJournalRecord } from '../interfaces/states/IElectronicJournalRecord';

export const getPrice = (isCouponType: boolean, selectedItem: IElectronicJournalRecord): string => {
  if (isCouponType) {
    return (selectedItem?.Quantity || 0).toString();
  } else {
    const price = parseFloat(selectedItem?.Price.replace(/[^\d.-]/g, ''));
    return convertCurrency(price);
  }
};

export const getItemName = (item: IElectronicJournalRecord, t: TFunction): string => {
  switch (item.Type) {
    case EJRecordTypes.Coupon:
      return t('Coupon'.toUpperCase());
    case EJRecordTypes.ItemFee:
      return t('Item_Fee_Total');
    case EJRecordTypes.TransactionFee:
      return t('Transaction_Fee_Total');
    case EJRecordTypes.TaxExemption:
      return t(item.Name);
    default:
      return t(item.Name);
  }
};

export const getPriceFromItems = (items: IElectronicJournalRecord[]) => {
  let price = 0;
  items.forEach(item => {
    price = price + parseFloat(item.Price.replace(/[^\d.-]/g, ''));
  });
  const numberPrice = convertCurrency(price);
  if (String(numberPrice) !== '$0.00') {
    return numberPrice;
  }
};

export const isManualTareLineItem = (item: CartItemViewData) =>
  item.lineItem?.quantity?.weightQuantity?.tare?.isManualFixedTare ||
  item.lineItem?.quantity?.weightQuantity?.tare?.isManualPercentage;

export const calculateGrossWeight = (
  tareWeight?: ITareWeight,
  quantity?: number,
  precision?: number,
): number => {
  const quantityNumber = quantity ?? 0;
  const tareValue = tareWeight?.TareValue ?? 0;
  return tareWeight?.IsManualPercentage
    ? Number(tareWeight?.GrossWeight || (quantityNumber / (1 - tareValue / 100)).toFixed(precision))
    : Number(tareWeight?.GrossWeight || (tareValue + quantityNumber).toFixed(precision));
};
